import * as React from 'react';

import DirectionSvg from '../../assets/direction.svg';

import styles from './onboarding-graphic-direction.module.css';

export class OnboardingGraphicDirection extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.direction}>
                <div className={styles.fade} />
                <DirectionSvg />
            </div>
        );
    }
}
